import { render, staticRenderFns } from "./VesselRecordFlagPieChart.vue?vue&type=template&id=1ced869a&scoped=true&"
import script from "./VesselRecordFlagPieChart.vue?vue&type=script&lang=js&"
export * from "./VesselRecordFlagPieChart.vue?vue&type=script&lang=js&"
import style0 from "./VesselRecordFlagPieChart.vue?vue&type=style&index=0&id=1ced869a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ced869a",
  null
  
)

export default component.exports